import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-secondary-profile',
  template: `
    <app-navigation-secondary-profile></app-navigation-secondary-profile>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationSecondaryProfileComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/compat/compat-navigation-secondary-profile.component.ts